import {IDataSourceAdapter} from '~/lib/dataSource';
import {createDeal, createSupplyPackage, fetchDeals, fetchSupplyPackages, updateDeal, updateSupplyPackage} from '~/modules/Pmp/api';
import {ISupplyPackage} from '~/modules/Pmp/models/SupplyPackage';
import {IDeal} from '~/modules/Pmp/models/Deal';

export const supplyPackagesAdapter: IDataSourceAdapter<ISupplyPackage> = {
    fetchRecords: fetchSupplyPackages,
    updateRecord: updateSupplyPackage,
    createRecord: createSupplyPackage
};

export const dealsAdapter: IDataSourceAdapter<IDeal> = {
    fetchRecords: fetchDeals,
    updateRecord: updateDeal,
    createRecord: createDeal
};
